<template>
    <v-dialog v-model="dialog" @click:outside="clearForm" max-width="576">
        <v-card class="pa-6 rounded-sm">
            <h6 class="text-h6 primaryDark--text">Направить по электронной почте</h6>
            <v-divider class="my-4" />
            <v-form ref="form" @submit.prevent="sendEmailNotification">
                <v-text-field type="email" :rules="[validationRules.required, validationRules.email]" v-model="email" label="E-mail" outlined color="black" />
                <div class="d-flex justify-end">
                    <v-btn @click="closeDialog" rounded class="mr-4" outlined color="gray">Отмена</v-btn>
                    <v-btn type="submit" rounded color="gray" class="white--text">Отправить</v-btn>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { validationRules } from '@/utils/validationRules';

export default {
    name: 'PreTrialDialog',
    props: ['id'],
    data: function() {
        return {
            dialog: false,
            email: null
        };
    },
    computed: {
        validationRules() {
            return validationRules;
        },
        isFormValid() {
            return this.$refs.form.validate();
        }
    },
    methods: {
        showDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
            this.clearForm();
        },
        sendEmailNotification() {
            if (!this.isFormValid) return;
            const emailData = { pretrial_notice_rid: this.id, email: this.email };
            this.$emit('sendEmailNotification', emailData);
            this.closeDialog();
        },
        clearForm() {
            this.$refs.form.resetValidation();
            this.email = null;
        }
    }
};
</script>

<style scoped></style>
